<div>
  <table class="m-table" aria-label="Highlights" style="width: calc(100% - 1.5rem)">
    <thead style="border-bottom: 1px solid black;">
    <tr>
      <th><span class="table-header">{{ "DAMAGE_EVENT.dateTime" | translate }}</span></th>
      <th><span class="table-header">{{ "DAMAGE_EVENT.licencePlate" | translate }}</span></th>
      <th><span class="table-header">{{ "DAMAGE_EVENT.severity" | translate }}</span></th>
      <th><span class="table-header">{{ "DAMAGE_EVENT.impactArea" | translate }}</span></th>
      <th><span class="table-header">{{ "DAMAGE_EVENT.reports" | translate }}</span></th>
    </tr>
    </thead>
    <tbody>
      @for (incident of damageEvents?.incidents; track incident.messageId) {
        <tr>
          <td><span> {{ incident.timestamp | dateConversion }}</span></td>
          <td><span> {{ incident.licencePlate }}</span></td>
          <td><span> {{ "DAMAGE_EVENT." + incident.severity | translate }}</span></td>
          <td><span> {{ "DAMAGE_EVENT." + incident.damageLocation | translate }}</span></td>
          <td>
            <span>
              <a class="icon-class-style" (click)="openReport(incident.messageId)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192" style="width: 1.5rem;
                        height: 1.5rem">
                  <path
                    d="M139.941 86H140v54H52V52h54v.059L98.059 60H60v72h72V93.941L139.941 86zM124 36v8h18.343L93.17 93.171l5.658 5.658L148 49.657V68h8V36h-32z"
                    style="fill: #007bc0;"/>
                </svg>
                {{ 'APP.pdfReport' | translate }}
              </a>
            </span>
          </td>
        </tr>
      }
    </tbody>
  </table>
  <div #scrollSentinel style="height: 10px; visibility: hidden;"></div>
</div>

<ngx-spinner
  bdColor="rgba(216,216,216,0.8)"
  fullScreen="true"
  template="
    <div style='display: flex; justify-content: center; align-items: center; height: 100%; width: 100%;'>
      <img src='{{ host }}/assets/loader/loader.gif' style='width: 100px; height: auto;' />
    </div>
  "
></ngx-spinner>
